import React, { useState, useEffect } from 'react';
import './FloatingChatButton.css';

function FloatingChatButton({ onOpen, isVisible = true }) {
  const [isHovered, setIsHovered] = useState(false);
  const [hasNewMessage, setHasNewMessage] = useState(false);

  // Animation effect for pulse
  useEffect(() => {
    const timer = setInterval(() => {
      setHasNewMessage(prev => !prev);
    }, 2000);

    return () => clearInterval(timer);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="floating-chat-button-container">
      <button
        className={`floating-chat-button ${isHovered ? 'hovered' : ''} ${hasNewMessage ? 'pulse' : ''}`}
        onClick={onOpen}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        title="Chat with us!"
      >
        <span className="chat-icon">
          <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round" className="chat-svg-icon" style={{ verticalAlign: 'middle', display: 'inline-block' }}>
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
        </span>
        <span className="chat-text">Chat</span>
      </button>

      {isHovered && (
        <div className="floating-chat-tooltip">
          <p>Need help? Ask our AI chatbot about our products and services!</p>
        </div>
      )}

      <div className="floating-chat-pulse"></div>
    </div>
  );
}

export default FloatingChatButton;
